var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4v3.2602C0 8.7733 1.2267 10 2.7399 10c.7998 0 1.5597.3495 2.0802.9568l8.1429 9.5c1.5964 1.8624 4.4776 1.8624 6.074 0l8.1429-9.5A2.7398 2.7398 0 0 1 29.2602 10C30.7733 10 32 8.7733 32 7.2602V4c0-2.2091-1.7909-4-4-4H4C1.7909 0 0 1.7909 0 4Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkPointer);
export default __webpack_public_path__ + "static/media/dark_pointer.ce478a0051b5b2e93c025ede69394cdc.svg";
export { ForwardRef as ReactComponent };